import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { requestPassword } from '../core/_requests'
import { useIntl } from 'react-intl'

const initialValues = {
  email: '',
}



export function ForgotPassword() {

  const intl = useIntl();
  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(useIntl().formatMessage({ id: 'Wrong_email_format' }))
      .min(3, useIntl().formatMessage({ id: 'Minimum_3_symbols' }))
      .max(50, useIntl().formatMessage({ id: 'Maksimum_50_symbols' }))
      .required(useIntl().formatMessage({ id: 'Email_is_required' })),
  })
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const AuthError = useIntl().formatMessage({ id: 'AUTH.VALIDATION.INVALID_LOGIN' })


  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email)
          .then(({ data: { result } }) => {
            setHasErrors(false)
            setLoading(false)

          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus(AuthError);
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          {hasErrors === undefined && (<h1 className='text-dark mb-3'>{intl.formatMessage({ id: 'Forgot Password' })} ?</h1>)}
          {/* end::Title */}

          {/* begin::Link */}
          {hasErrors === undefined && (<div className='text-gray-400 fw-bold fs-4'>{intl.formatMessage({ id: 'Enter your email to reset your password.' })}</div>)}
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {intl.formatMessage({ id: 'FORGOT-PASSWORD-ERROR' })}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <>
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>{intl.formatMessage({ id: 'Sent password reset. Please check your email' })}</div>
            </div>

            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_signup_form_cancel_button'
                className='btn btn-lg btn-light-primary w-100 mb-5'
              >
                {intl.formatMessage({ id: 'Login' })}
              </button>
            </Link>
          </>
        )}
        {/* end::Title */}

        {/* end::Form group */}
        {hasErrors === undefined && (
          <>
            {/* begin::Form group */}
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({ id: 'Email' })}</label>
              <input
                type='email'
                placeholder=''
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  { 'is-invalid': formik.touched.email && formik.errors.email },
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='d-flex flex-wrap justify-content-center pb-lg-0 gap-5'>
              {/* <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-lg btn-primary fw-bolder me-4'
              >
                <span className='indicator-label'>{intl.formatMessage({ id: 'Submit' })}</span>
                {loading && (
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button> */}
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-lg btn-primary   mb-5'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'Submit' })}</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {intl.formatMessage({ id: 'Please_wait' })}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <Link to='/auth/login'>
                <button
                  type='button'
                  id='kt_login_password_reset_form_cancel_button'
                  className='btn btn-lg btn-light-primary fw-bolder'
                  disabled={formik.isSubmitting && !formik.isValid}
                >
                  {intl.formatMessage({ id: 'Cancel' })}
                </button>
              </Link>{' '}
            </div>
          </>
        )}
        {/* begin::Form group */}

        {/* end::Form group */}
      </form>
    </>
  )
}
